import React, { useState } from 'react';
import { useEmailVerification } from '../../hooks/useEmailVerification';
import styles from '../../styles/EmailVerificationBanner.module.css';

interface EmailVerificationBannerProps {
  userEmail: string;
  onDismiss?: () => void;
}

const EmailVerificationBanner: React.FC<EmailVerificationBannerProps> = ({ userEmail, onDismiss }) => {
  const [isDismissed, setIsDismissed] = useState(false);
  const { resendVerification, isResending, message } = useEmailVerification();

  const handleResendVerification = async () => {
    await resendVerification();
  };

  const handleDismiss = () => {
    setIsDismissed(true);
    if (onDismiss) {
      onDismiss();
    }
  };

  if (isDismissed) {
    return null;
  }

  return (
    <div className={styles.banner}>
      <div className={styles.content}>
        <div className={styles.iconAndText}>
          <span className={styles.icon}>⚠️</span>
          <div className={styles.textContent}>
            <p className={styles.title}>Email Verification Required</p>
            <p className={styles.description}>
              Please verify your email address <strong>{userEmail}</strong>. Check your inbox for the verification link.
            </p>
            {message && (
              <p className={message.type === 'success' ? styles.successMessage : styles.errorMessage}>
                {message.text}
              </p>
            )}
          </div>
        </div>
        <div className={styles.actions}>
          <button
            onClick={handleResendVerification}
            disabled={isResending}
            className={styles.resendButton}
          >
            {isResending ? 'Sending...' : 'Resend Email'}
          </button>
          <button onClick={handleDismiss} className={styles.dismissButton}>
            ✕
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationBanner;
